import StatusGanttFragment from "@src/common/fragments/StatusGantt.fragment";
import { calculateTimelineEvent } from "@src/pages/Dashboard/hooks/useTimelineEvent";
import React from "react";
import TimelineCard from "./TimelineCard";
import styles from "./TimelineRow.module.scss";
import { useAnimatedItems } from "../hooks/useAnimatedItems";

interface TimelineRowProps {
  size: number;
  groupHeight: number;
  group: Sentinel.Timeline.GroupedEvent;
  start: Date;
  end: Date;
};

const TimelineRow: React.FC<TimelineRowProps> = ({
  size,
  groupHeight,
  group,
  start,
  end,
}) => {
  const { displayItems, isExiting } = useAnimatedItems(group?.events || [], 200);

  return (
    <div className={styles.row} style={{ height: groupHeight }}>
      {displayItems.map((event) => {
        const { leftPx, widthPx, shouldRender } = calculateTimelineEvent(
          event,
          start,
          end,
          size
        );

        if (!shouldRender) {
          return null;
        }

        const eventIsExiting = isExiting(event);

        return (
          <React.Fragment key={event.id}>
            <TimelineCard
              leftPx={leftPx}
              widthPx={widthPx}
              event={event}
              isExiting={eventIsExiting}
            />
            <div
              className={eventIsExiting ? styles.exiting : ""}
              style={{
                position: "absolute",
                left: `${leftPx + 14}px`,
                top: 4,
              }}
            >
              <StatusGanttFragment event={event} />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TimelineRow;
